export const CENTERS_ADMIN_ACCESS_MESSAGE =
  "No tiene acceso a Mis consultorios porque el perfil seleccionado no tiene activo el check de administrador. Solicite a un administrador que active este permiso en el perfil del consultorio.";

export const hasCentersAdminAccess = (doctorProfile = {}) =>
  doctorProfile?.isAdmin === true;

export const getStoredDoctorProfile = () => {
  try {
    return JSON.parse(sessionStorage.getItem("doctorProfile")) || {};
  } catch (error) {
    return {};
  }
};
